import { AvorionGalaxyUI } from './avorionGalaxyUI';

export class AvorionGalaxy {
  private ui: AvorionGalaxyUI = new AvorionGalaxyUI();
  private activeGalaxy: string;

  public constructor(private render: (data, afterRender: () => void) => {}, public galaxyData: Array<Array<any>>) {
    this.ui.onGalaxyChange(this.handleGalaxyChange.bind(this));

    this.activeGalaxy = this.ui.galaxyListElement.val().toString();
    if (this.activeGalaxy !== '__new__') {
      this.ui.galaxyNameWrapperElement.hide();
    }
  }

  private handleGalaxyChange(galaxy: string) {
    this.switchToGalaxy(galaxy);
  }

  private switchToGalaxy(galaxy: string) {
    // Push current field values in galaxyData (might have changed since page was loaded)
    for (let key in this.galaxyData[this.activeGalaxy]) {
      this.galaxyData[this.activeGalaxy][key] = this.ui.getGalaxyFieldValue(key);
    }

    // Set field values to new galaxyData
    if (galaxy === '__new__') {
      // Start new galaxy
      this.ui.galaxyNameElement.val('');
      this.ui.galaxyNameWrapperElement.show();
    } else {
      // Load existing galaxy
      this.ui.galaxyNameElement.val(galaxy);
      this.ui.galaxyNameWrapperElement.hide();
    }

    for (let key in this.galaxyData[galaxy]) {
      this.ui.setGalaxyFieldValue(key, this.galaxyData[galaxy][key]);
    }

    this.activeGalaxy = galaxy;
  }
}
